import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { PackageIcon } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { AnalysisDataExtractionJobs } from './AnalysisDataExtractionJobs';
import { ProductMasterPreview } from './ProductMasterPreview';
import type { SimpleAccount } from '@/lib/types';

interface ProductMasterExtractionProps {
  account: SimpleAccount;
}

/**
 * 商品マスタ抽出タブのコンテンツ（FKV3-12589）
 * プレビュー・実行ログをサブタブで切り替える（他メニューと同じ構成）
 */
export function ProductMasterExtraction({ account }: ProductMasterExtractionProps) {
  const [activeTab, setActiveTab] = useState('preview');

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h5" sx={{ mb: 3, display: 'flex', alignItems: 'center' }}>
        <PackageIcon size={24} style={{ marginRight: 8 }} />
        商品マスタ抽出
      </Typography>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="preview">プレビュー</TabsTrigger>
          <TabsTrigger value="logs">実行ログ</TabsTrigger>
        </TabsList>

        <TabsContent value="preview" className="mt-6">
          <ProductMasterPreview account={account} onSubmitted={() => setActiveTab('logs')} />
        </TabsContent>

        <TabsContent value="logs" className="mt-6">
          <AnalysisDataExtractionJobs account={account} menuType="product_master" />
        </TabsContent>
      </Tabs>
    </Box>
  );
}
